import { useState, useEffect } from 'react';

export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const updateMatches = () => {
      setMatches(mediaQuery.matches);
    };

    // Initial check
    updateMatches();

    // Add listener for changes in viewport size
    const listener = () => {
      updateMatches();
    };
    mediaQuery.addListener(listener);

    // Clean up listener when component unmounts
    return () => {
      mediaQuery.removeListener(listener);
    };
  }, [query]);

  return matches;
};
